import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

const getUserEmailDuplicate = (userID: any, userEmail: any) => {
  let queryString = `userEmail=${userEmail}`;
  if (userID) queryString = `ID=${userID}&userEmail=${userEmail}`;
  return queryString;
};

const getFastFiledEmailDuplicate = (userID: any, fastFieldEmail: any) => {
  let queryString = `fastFieldEmail=${fastFieldEmail}`;
  if (userID) queryString = `ID=${userID}&fastFieldEmail=${fastFieldEmail}`;
  return queryString;
};

const getUserNameDuplicate = (userID: any, userName: any) => {
  let queryString = `userName=${userName}`;
  if (userID) queryString = `ID=${userID}&userName=${userName}`;
  return queryString;
};

export const usersApiKeyStore = {
  getUsers: (): QueryKeyConfig => ({
    queryKey: [`GET_USERS`],
    route: `/User`,
  }),
  getUserByID: (userID?: number): QueryKeyConfig => ({
    queryKey: [`GET__USER_BY_ID`, userID],
    route: `/User/${userID}`,
  }),
  getUserDetails: (): QueryKeyConfig => ({
    queryKey: [`GET__USER_DETAILS`],
    route: `/User/Details`,
    retry: 0,
  }),

  getInspectorTeamforManager: (): QueryKeyConfig => ({
    queryKey: [`GET__USER_INSPECTOR_TEAM_MANAGER`],
    route: `/User/GetInspectorTeamforManager`,
  }),

  getUsersByRole: (roleCode: string): QueryKeyConfig => ({
    queryKey: [`GET_USERS_BY_ROLE`],
    route: `/User/GetUsersByRole?roleCode=${roleCode}`,
  }),
  createUser: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_USER`],
    route: `/User`,
    action: 'POST',
  }),
  updateInspectors: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_INSPECTORS`],
    route: `/User/inspectors`,
    action: 'POST',
    disableSnackbar: true,
  }),
  updateUser: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_USER`],
    route: `/User`,
    action: 'PUT',
  }),
  deleteUser: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_USER`, id],
    route: `/User/${id}`,
    action: 'DELETE',
  }),
  getUserSkillSets: (id: any): QueryKeyConfig => ({
    queryKey: [`GET_USER_SKILL_SETS`, id],
    route: `/User/UserSkillsets/${id}`,
  }),
  getEmployeeSchedules: (): QueryKeyConfig => ({
    queryKey: [`GET_EMPLOYEE_SCHEDULES`],
    route: `/User/GetEmployeeSchedules`,
  }),
  validateUserEmail: (userID?: any, userEmail?: string): QueryKeyConfig => ({
    queryKey: [`VALIDATE_USER_EMAIL`, userID, userEmail],
    route: `/User/CheckForDuplicateEmail?${getUserEmailDuplicate(userID, userEmail)}`,
  }),
  validateFastFieldEmail: (userID?: any, fastFieldEmail?: string): QueryKeyConfig => ({
    queryKey: [`VALIDATE_FAST_FILED_EMAIL`, userID, fastFieldEmail],
    route: `/User/CheckForDuplicateFastFieldEmail?${getFastFiledEmailDuplicate(userID, fastFieldEmail)}`,
  }),
  validateUserName: (userID?: any, userName?: string): QueryKeyConfig => ({
    queryKey: [`VALIDATE_FAST_FILED_EMAIL`, userID, userName],
    route: `/User/CheckForDuplicateUserName?${getUserNameDuplicate(userID, userName)}`,
  }),
  getScheduledWOInspectors: (): QueryKeyConfig => ({
    queryKey: [`GET_SCHEDULED_WO_INSPECTORS`],
    route: `/User/GetScheduledWOInspectors`,
  }),
  getAssignedRoles: (): QueryKeyConfig => ({
    queryKey: [`GET_ASSIGNED_ROLES`],
    route: `/User/GetUsersAssignedRoles`,
  }),
};
